import { Component } from '@angular/core';

@Component({
  selector: 'app-membership',
  standalone: false,
  templateUrl: './membership.html',
  styleUrl: './membership.css'
})
export class Membership {

}
